import { HStack } from '@cardboard-ui/react';
import { Text } from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import React from 'react';
import { graphql, useFragment } from 'utils/graphClient';
import { InviteeOverview$key } from './__generated__/InviteeOverview.graphql';

const eventOverview_invitations = graphql`
  fragment InviteeOverview on Event {
    invitations {
      count
      attendingCount: count(rsvpState: ATTENDING)
    }
  }
`;

interface InviteeOverviewProps {
  invitations: InviteeOverview$key;
  canInvite: boolean;
}

export const InviteeOverview = ({
  invitations: _invitations,
  canInvite,
}: InviteeOverviewProps) => {
  const { invitations } = useFragment(eventOverview_invitations, _invitations);

  if (!invitations?.count) {
    return (
      <HStack>
        <Text fontSize="sm" color="gray.500">
          {canInvite ? t`Invite people to the event` : t`No guest list`}
        </Text>
      </HStack>
    );
  }

  const amountAttending = invitations?.attendingCount || 0;

  return (
    <Text
      color={amountAttending ? 'green.500' : 'gray.500'}
      _dark={{ color: amountAttending ? 'green.400' : 'gray.200' }}
      fontSize="sm"
    >
      {amountAttending ? t`${amountAttending} attending` : t`Nobody confirmed`}
    </Text>
  );
};
